import createModel from 'utils/model'
import {createMoment, getMomentDetails, editMoment} from 'crm/services/company-moments'

export default createModel({
    namespace: 'crm_createCompanyMoment',
    state: {
        list: [],
        total: 0,
        current: 1,
        momentDetails: null, // 单个详情
    },
    effects: {
        *createMoment({payload, callback}, {call}) {
            const res = yield call(createMoment, payload)
            if (res) {
                callback && callback()
            }
        },

        *editMoment({payload, callback}, {call}) {
            const res = yield call(editMoment, payload)
            if (res) {
                callback && callback()
            }
        },

        *getMomentDetails({payload, callback}, {call, put}) {
            const res = yield call(getMomentDetails, payload)

            if (res && res.data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        momentDetails: res.data,
                    },
                })
                callback && callback(res.data)
            }
        },
    },
})
